// extracted by mini-css-extract-plugin
module.exports = {"generatedCodesSection__box":"generatedCodesSection_generatedCodesSection__box__8q7_N","generatedCodesSection__title":"generatedCodesSection_generatedCodesSection__title__X3uPM"};